import React from 'react';

type Props = {
  checked: boolean,
  onToggle: ( toggleTo: boolean ) => void;
}

const Checkbox = ( props: Props ) => {
  return (
    <div
      className='Checkbox'
      onClick={ () => props.onToggle( !props.checked ) }
    >
      {props.checked && (
        <i className='icon icon-check'/>
      )}
    </div>
  );
}

export default Checkbox;